import './styles.css';
import React, {Component} from 'react';
import {Button} from 'packages/components';
import {sendGAEvent} from "../../../../utils/analytics";
import {decodeHTML5} from "../../../../actions/metrics";
import {NODE_RIBBONS, BUTTON_GROUP} from "./constants";
import store from '../../../../store';
import {setFromData} from "../../../../actions/navbar"
class RibbonCategories extends Component{
    constructor(props){
        super(props);
        this.parentScroll;
        this.state = {
            visibleItems: props.visibleItems
        }
        this.indexOfSelectedButton = -1;
        this.focusHandler = props.focusHandler;
        this.history = props.history;
        this.goToLink = this.goToLink.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.ribbonIndex = props.index;
        this.someRibbonIsSelected = false;
        this.ribbonName = props.ribbonName;
    }

    goToLink(uri, title){
      const resume = store.getState().navbar;
      store.dispatch(setFromData({
        ribbon_title : title,
      }));
      if(resume && resume.nodes && resume.nodes.length > 0) {
        const node = resume.nodes.find(node => this.history.location.pathname.includes(node.code));
        const _item = this.state.visibleItems.find(({item}) => item.href === uri).item;
        if(node && node.text && node.text !== '') {
          sendGAEvent({
            hitType: 'event',
            eventCategory: NODE_RIBBONS.replace('{{NODE_NAME}}', node.text),
            eventAction: decodeHTML5(BUTTON_GROUP),
            eventLabel: _item && _item.title ? _item.title : ''
          });
        }
      }
        this.history.push(uri);
    }

    handleOnClick(uri, title, id_rol){
        if (this.props.onClick && typeof this.props.onClick === 'function') this.props.onClick(id_rol, title);
        else this.goToLink(uri, title);
    }

    onFocus(event) {
        if(typeof this.focusHandler === 'function'){
            this.focusHandler(event);
        }
        let element = event.target;
        this.parentScroll.scrollLeft = element.offsetLeft;
    }

    componentWillReceiveProps(nextProps){
        if(JSON.stringify(nextProps.visibleItems) !== JSON.stringify(this.state.visibleItems)){
            this.setState({visibleItems: nextProps.visibleItems});
        }
    }

    componentDidMount(){
        if(this.indexOfSelectedButton>-1){
            let element = this.parentScroll.children[this.indexOfSelectedButton];
            this.parentScroll.scrollLeft = element.offsetLeft;
        }
        if(this.ribbonIndex === 0){
            window.SpatialNavigation.focus('.selected');
        }
    }

    render(){
        const { history: { location: { pathname } } } = this.props;
        return (
            <div className={`ribbon-items ribbon-categories ${pathname.includes('/mundial') ? 'mundial' : ''}`} ref={(el) => this.parentScroll = el}>
                {
                    this.state.visibleItems.map((node, index) => {
                        const uri = node.item.href;
                        const title = node.item.title;
                        const key = Math.random() * 10;
                        const variant = node.item.selected ? 'primary' : 'default';
                        const dataOptions = {};
                        const disableLeft = { "data-sn-left": '' };
                        const disableRight = { "data-sn-right": '' };
                        const { item: { dataSnUp = false, dataSnDown = false } = {}} = node;
                        let className = node.item.selected ? 'selected' : '';
                        this.someRibbonIsSelected = this.someRibbonIsSelected || node.item.selected;

                        if (this.ribbonIndex === 0 && index == 0 && !this.someRibbonIsSelected) {
                            className = 'selected';
                        }

                        if (dataSnUp) {
                            dataOptions['data-sn-up'] = dataSnUp;
                        }

                        if (dataSnDown) {
                            dataOptions['data-sn-down'] = dataSnDown;
                        }

                        this.indexOfSelectedButton = node.item.selected ? index : this.indexOfSelectedButton;

                        return (
                            <Button
                                id={key}
                                key={key}
                                type="button"
                                variant={variant}
                                onClick={()=>{this.handleOnClick(uri, title, node.item.id_rol)}}
                                onFocus={this.onFocus}
                                className={`focusable ${className} ${title}`}
                                dataOptions={dataOptions}
                                blockedLeft={pathname.includes('/mundial2022_partidos') && index === 0 ? disableLeft : ''}
                                blockedRight={(pathname.includes('/mundial2022_partidos') && index === 3) || (index === this.state.visibleItems.length - 1) ? disableRight : ''}
                            >
                                <div
                                >
                                    {title}
                                </div>
                            </Button>
                        );
                    })
                }
            </div>
        );
    }
}

export default RibbonCategories;



// WEBPACK FOOTER //
// ./src/components/RibbonNew/RibbonTypes/RibbonCategories/index.jsx